import { render, staticRenderFns } from "./transferguide.vue?vue&type=template&id=57904d44&scoped=true&"
import script from "./transferguide.vue?vue&type=script&lang=js&"
export * from "./transferguide.vue?vue&type=script&lang=js&"
import style0 from "./transferguide.vue?vue&type=style&index=0&id=57904d44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57904d44",
  null
  
)

export default component.exports